import { LoadableAfterPaint } from '@confluence/loadable';

export {
	SpaceNavigation,
	SpaceNavigationLoader,
	SpaceNavigationLoadingSkeleton,
} from './SpaceNavigation';

export { AutomationIcon } from './SpaceNavigation/AutomationNavigation';
export { GraphBarIcon } from './SpaceNavigation/AnalyticsNavigation';

export { GlobalNavigation } from './GlobalNavigation';

export const AdminNavigationLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AdminNavigation" */ './AdminNavigation'))
			.AdminNavigation,
});

export { SpaceAdminNavigation } from './SpaceAdminNavigation';

export { HubSettingsNavigation } from './HubSettingsNavigation';
